import { ComponentProps } from 'react';

import { FormSelectField } from '@sbv-clients/ui-forms';

type FormatFieldProps = ComponentProps<typeof FormSelectField>;

const options = [
  { id: '1', label: 'True', value: '1' },
  { id: '2', label: 'False', value: '2' },
];

export const HppdByPositionFormField = (props: FormatFieldProps) => {
  return <FormSelectField {...props} options={options} size="small" />;
};
